import { match } from "path-to-regexp";
const removeSearch = (url) => url.split("?")[0];
export const urlParser = (patterns, url) => {
    var _a;
    if (!url)
        return {};
    const matchers = patterns.map((pattern) => match(pattern, { decode: decodeURIComponent })(removeSearch(url)));
    const res = matchers.find((matcher) => !!matcher);
    return (_a = res === null || res === void 0 ? void 0 : res.params) !== null && _a !== void 0 ? _a : {};
};
